module.exports = __webpack_public_path__ + "img/ic-arrow.-footer.ed936f47.png";